<template>
	<div>
		<div>
			<!-- 最小宽度 -->
			<div style="width: 980px;margin: 0 auto;">
				<div class="head">
					<el-carousel :interval="2000" arrow="always" height='200px'>
						<el-carousel-item v-for="(item,index) in headimgList" :key="index">
							<img :src="item.url" style="width: 100%;" />
						</el-carousel-item>
					</el-carousel>
				</div>

				<!-- 首页导航 -->
				<div class="navigation">
					<el-row style="width: 100%;">
						<el-col class="menu" :span="2">
							<div class="finger" @click="homePage" :class="myindex == '/'? 'menu-background':''">首页</div>
						</el-col>
						<el-col class="menu" :span="2">
							<div class="finger" @click="welcome" :class="myindex == '/welcome'? 'menu-background':''">
								欢迎辞</div>
						</el-col>
						<el-col class="menu" :span="3">
							<div class="finger" @click="organization"
								:class="myindex == '/organization'? 'menu-background':''">组织机构</div>
						</el-col>
						<el-col class="menu" :span="2">
							<div class="finger" @click="schedule" :class="myindex == '/schedule'? 'menu-background':''">
								大会日程</div>
							
						</el-col>
						<el-col class="menu" :span="3">
							<div @click="register" class="finger">会议回放</div>
						</el-col>
						<el-col class="menu" :span="3">
							<div class="finger" @click="goLive">下届预告</div>
						</el-col>
						<el-col class="menu" :span="3">
							<div class="finger" @click="stay" :class="myindex == '/stay'? 'menu-background':''">照片直播
							</div>
						</el-col>
						<el-col class="menu" :span="3">
							<div class="finger" @click="guide" :class="myindex == '/guide'? 'menu-background':''">每日会讯
							</div>
						</el-col>
						<el-col class="menu" :span="3">
							<div class="finger" @click="download" :class="myindex == '/download'? 'menu-background':''">
								资料下载</div>
						</el-col>
						<!--      <el-col class="menu" :span="2">联系我们</el-col>
		      <el-col class="menu" :span="2">个人中心</el-col> -->
					</el-row>
				</div>


				<el-row style="width: 100%;margin-top: 20px;">
					<el-col :span="15">
						<router-view></router-view>
					</el-col>
					<el-col :span="8" :offset="1">
						<important-notice></important-notice>
					</el-col>
				</el-row>


				<div class="exhibition" v-show="$route.fullPath == '/'">
					<div class="flex" style="margin: 20px 0;">
						<div class="line" style="width: 42%;"></div>
						<div class="title">参展企业</div>
						<div class="line" style="width: 42%;"></div>
					</div>
					<exhibition></exhibition>
				</div>
			</div>

			<!-- 底部 -->
			<div>
				<div class="bottom">
					<p style="color: red;font-size: 13px;margin-top: 40px;">
						本网站为“中华医学会第一次全国细菌真菌感染学术会议（BISC2021）”唯一指定会议信息发布官方网站，任何媒体、网站或个人转载使用时必须注明：“文章来源：感知域”。违反上述声明者，本网将追究其相关法律责任。
					</p>
					<p style="color: #fff;font-size: 13px;">技术支持 : 感知域提供技术支持 <span
							style="color: #fff;font-size: 13px;margin-left: 20px;">京ICP备20026196号-1</span></p>
				</div>
			</div>
		</div>
		<div style="position: fixed;top: 260px;right: 0;width: 15%;text-align: center;">
			<img src="../assets/QRcode.png" alt="" width="100px" height="100px">
			<p>扫一扫，进入手机微官网</p>
		</div>
		<!-- 5.17新增 -->
		<div>

		</div>
	</div>

</template>

<script>
	import importantNotice from "@/components/ImportantNotice/ImportantNotice.vue";
	import exhibition from "@/components/exhibition/exhibition.vue";

	export default {
		data() {
			return {
				myindex: '',
				headimgList: [{
					url: require("@/assets/headImg/head.jpg"),
					id: 1
				}]
			}
		},
		components: {
			importantNotice,
			exhibition
		},
		methods: {
			register() {
				// window.location.href = "https://app7VA52GBr7813.h5.xiaoeknow.com"
				window.open("https://app7VA52GBr7813.h5.xiaoeknow.com")
				// if (JSON.parse(localStorage.getItem("user"))) {
				// 	this.$router.push({
				// 		path: '/personalCenter'
				// 	})
				// } else {
				// 	this.$router.push({
				// 		path: '/seleteSignln'
				// 	})
				// };
				// this.myindex = this.$route.fullPath
			},

			homePage() {
				this.$router.push({
					path: '/'
				});
				this.myindex = this.$route.fullPath
			},

			stay() {
				// window.location.href = "http://live.jfoto.cn/gti/d04d0ea7"
				window.open("http://live.jfoto.cn/gti/d04d0ea7")
				// if (localStorage.getItem("user")) {
				// 	this.$router.push({
				// 		path: '/stay'
				// 	});
				// } else {
				// 	var r = confirm("您当前没有登录，请先登录，方可进行投稿");
				// 	if (r == true) {
				// 		localStorage.removeItem('user');
				// 		this.$router.push({
				// 			path: '/signIn'
				// 		})
				// 	}
				// }

				// alert("此功能后续开放....")
			},

			guide() {
				// window.location.href = "https://mp.weixin.qq.com/s/VMQ6tNxb_dMuOHAa2v7vGQ"
				// this.$router.push({
				// 	path: 'guide'
				// });
				// this.$router.push({
				// 	path: '/wonderful'
				// })
				window.open("http://mp.weixin.qq.com/mp/homepage?__biz=MzAwNDA4ODk3NQ==&hid=3&sn=6eb5d61ab747eaac9555ab9721b6a09f&scene=18#wechat_redirect")

				// this.myindex = this.$route.fullPath	   
			},

			goLive() {
				// if(localStorage.getItem("user")){
				// 	let info = JSON.parse(localStorage.getItem("user"))
				// 	this.$api.getUserLiveUrl({phone:info.user.phone}, res => {
				// 		if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
				// window.location.href=res.data.c
				this.$router.push({
					path: '/LivePage',
					// query: {
					// 	'index': '0'
					// }
				})
				// 		} else {
				// 			this.$message.error(res.data.rm);
				// 		}
				// 	});
				// }else{
				// 	var r = confirm("您当前没有登录，请先注册会议网站并进行登录，方可观看本次大会直播");
				// 	if (r == true) {
				// 		localStorage.removeItem('user');
				// 		this.$router.push({
				// 			path: '/signIn'
				// 		})
				// 	}
				// }
				// this.$router.push({
				// 	path: '/seleteLive'
				// });
				// this.myindex = this.$route.fullPath	
			},


			schedule() {
				this.$router.push({
					path: '/schedule',
					query: {
						id: 1
					}
				})

			},

			download() {
				this.$router.push({
					path: 'download'
				})
			},


			welcome() {
				this.$router.push({
					path: '/welcome'
				});
				// this.myindex = this.$route.fullPath;
				// console.log(this.myindex)
			},

			organization() {
				this.$router.push({
					path: '/organization'
				});
				// this.myindex = this.$route.fullPath
			}
		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (flag) {
				this.$router.push({
					path: '/phone'
				})
			};

		},
		mounted() {
			this.myindex = this.$route.fullPath
		},
		watch: {
			$route() {
				this.myindex = this.$route.fullPath
			}
		}

	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/style.scss';

	.head {
		width: 100%;
	}


	.navigation {
		background-color: #2764f1;
		text-align: center;
		height: 40px;
		color: #fff;
		line-height: 40px;
		font-size: 15px;
		// background-color: $background;
	}

	.menu:hover {
		background-color: #a4dfff;
	}

	.menu-background {
		background-color: #a4dfff;
	}

	.bottom {
		width: 100%;
		height: 100px;
		background-color: #27282d;
		margin-top: 20px;
		text-align: center;
		overflow: hidden;
	}

	.finger {
		cursor: pointer
	}

	.exhibition {
		width: 912px;
		margin: 70px auto;
		margin-top: 50px;
	}

	.title {
		font-size: 25px;
		font-weight: bold;
		color: #666;
	}
</style>
